export const MIN_TITLE_LENGTH = 2
export const MAX_TITLE_LENGTH = 100

export const MAX_TEXT_LENGTH = 15000
